import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

// Predefined color scheme
const colors = schemeCategory10;

/**
 * Generates a distinct color based on an index within a total number of items.
 * Uses a predefined color scheme and wraps around if the index exceeds the scheme size.
 * 
 * @param index - The index of the item (0-based).
 * @param totalItems - The total number of items needing distinct colors.
 * @returns A color string (e.g., "#1f77b4").
 */
export const distinctColor = (index: number, totalItems: number): string => {
  // Simple modulo to cycle through the predefined colors
  return colors[index % colors.length];
}; 